module.exports = __webpack_public_path__ + "static/media/result-2-en.b3a9cb84.png";